module.exports = __webpack_public_path__ + "img/avatar.1d88924d.png";